import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { NSC_URN_OPERATIONS } from '@/constants';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import EventsTable from '../events/EventsTable';
import HistoricTabs from '../events/HistoricTabs';

export default function GroveIlkActivityPage() {
  const { ilk } = useParams();

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 50
  });

  const [data, error] = useApi({
    url: `/groups/grove/ilks/${ilk}/`
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(NSC_URN_OPERATIONS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [filters]);

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="6"
              />
            }>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name} Activity</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {ilk}
              </Flex>
            </Flex>
          </EntityName>
        }>
        <HistoricTabs ilk={ilk} />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>
        <EventsTable
          ilk={ilk}
          sorting={sorting}
          pagination={pagination}
          filters={filters}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
